var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('h3',[_vm._v("Nested draggable")]),_c('nested-draggable',{attrs:{"tasks":_vm.list}})],1),_c('rawDisplayer',{staticClass:"col-3",attrs:{"value":_vm.list,"title":"List"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }